import { render, staticRenderFns } from "./tableApprove.vue?vue&type=template&id=2c65e5c2"
import script from "./tableApprove.vue?vue&type=script&lang=js"
export * from "./tableApprove.vue?vue&type=script&lang=js"
import style0 from "./tableApprove.vue?vue&type=style&index=0&id=2c65e5c2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports